import { GetVerificationCodeBatchesParams } from "@bvhi/backend-api/apis";
import { Card, Stack } from "@bvhi/ui-base";
import { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { BVHINavigationCreateEntityButton } from "../../../../components/bvhi-navigation-create-entity-button";
import { NavigationBar } from "../../../../components/navigation-bar";
import { useBVHIDataGridFilter } from "../../../../hooks/use-bvhi-datagrid-Filter";
import { Route } from "../../../../routes/_main/app/verification-codes.index";
import { VerificationCodesDataGrid } from "./components/datagrid/verification-codes-datagrid";
import { defaultVerficationCodesFilter } from "./components/default-verfication-codes-filter";
import { VerificationCodeErrorAlerts } from "./components/verification-codes-error-alerts";
import { VerificationCodesFilterCard } from "./components/verification-codes-filter-card";
import { useVerificationBatchSortParams } from "./hooks/use-verification-batch-sort-params";

export const VerificationCodesListView = () => {
  const { t } = useTranslation(["verification-codes"]);
  const searchParams = Route.useSearch();
  const { getSortConfig } = useVerificationBatchSortParams();
  const { resetFilter, handleFilterChange, handleDataGridChange, requestParams } = useBVHIDataGridFilter<GetVerificationCodeBatchesParams>(
    defaultVerficationCodesFilter,
    Route.fullPath,
    getSortConfig,
    searchParams
  );

  return (
    <>
      <NavigationBar
        showBreadcrumbs={true}
        actions={[
          <BVHINavigationCreateEntityButton
            key={0}
            entity={t("verification.codes.verification.codes")}
            navigateTarget={{ to: "/app/verification-codes/create" }}
          />,
        ]}
      />
      <Stack pt={2} spacing={2}>
        <VerificationCodeErrorAlerts />
        <VerificationCodesFilterCard filter={requestParams} onChange={handleFilterChange} onReset={resetFilter} />
        <Suspense fallback={<Card sx={{ height: 300, minHeight: 300 }} />}>
          <VerificationCodesDataGrid updateCallback={handleDataGridChange} />
        </Suspense>
      </Stack>
    </>
  );
};
